var replaceSpaceToDashAndLowerCase = function replaceSpaceToDashAndLowerCase(value) {
  return value.replace(/ /g, "-").toLowerCase();
};
export default replaceSpaceToDashAndLowerCase;